import { useEffect, useState } from 'react'
import DataDetail from './components/DataDetail'
import DataTransferBar from './components/DataTranferGraficos/DataTransGraph'
import { useAppSelector } from '../../../../../redux/hooks'
import {
  getyear, getyearglobal, getmonth, getmonthglobal, getDataGrafica, getDataGraficaglobal,
  getDataGraficaanual, getDataGraficaanualGlobal, getDataGraficatipo, getDataGraficatipoGlobal, getDataGraficatodosanios, getDataGraficatodosaniosglobal
} from './requests/request'
import { useAuth } from '../../../auth'
export default function GeneralDetail(props: any) {
  const [Datos, setDatos] = useState([])
  const [flag, setflag] = useState(1)
  const [year, setyear] = useState<any>([{
    year: ''
  }])
  const [oneyear, setoneyear] = useState('')
  const [month, setmonth] = useState<any>([])
  const [onemoth, setonemonth] = useState('')
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)

  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type) || "CloudGlobal";
  const [Evento, setEvento] = useState(1)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const Plansus = useAppSelector(state => state.planSlice.plans)
  const { currentUser } = useAuth()


  useEffect(() => {
    if (Id !== 0 && Type !== 'Global' && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
      if (tenant === 0) {
        getmonth(Id).then(response => {
          // Obtener la lista de años únicos
          const uniqueYearsList = Array.from(new Set(response.data.map((m: any) => m.anio)));
          setyear(uniqueYearsList.map(year => ({ year })));
          if (oneyear !== '') {
            const filteredMonths = response.data.filter((m: any) => m.anio === parseInt(oneyear));
            setmonth(filteredMonths);
          }
        })
      }
      else {
        getmonthglobal(Id, tenant).then(response => {
          // Obtener la lista de años únicos
          const uniqueYearsList = Array.from(new Set(response.data.map((m: any) => m.anio)));
          setyear(uniqueYearsList.map(year => ({ year })));
          if (oneyear !== '') {
            const filteredMonths = response.data.filter((m: any) => m.anio === parseInt(oneyear));
            setmonth(filteredMonths);
          }
        })
      }

    }
  }, [Id, Type, oneyear])

  /*************************GLOBAL poc*************************************** */
  useEffect(() => {
    if (Id && Type && currentUser?.ListPermiso?.includes('Ctx.DataUsage')) {
      if (tenant === 0) {
        getmonth(-1).then(response => {
          // Obtener la lista de años únicos
          const uniqueYearsList = Array.from(new Set(response.data.map((m: any) => m.anio)));
          setyear(uniqueYearsList.map(year => ({ year })));
          if (oneyear !== '') {
            const filteredMonths = response.data.filter((m: any) => m.anio === parseInt(oneyear));
            setmonth(filteredMonths);
          }
        })
      }
      else if (tenant !== 0) {
        getmonthglobal(-1, tenant).then(response => {
          // Obtener la lista de años únicos
          const uniqueYearsList = Array.from(new Set(response.data.map((m: any) => m.anio)));
          setyear(uniqueYearsList.map(year => ({ year })));
          if (oneyear !== '') {
            const filteredMonths = response.data.filter((m: any) => m.anio === parseInt(oneyear));
            setmonth(filteredMonths);
          }
        })
      }

    }
  }, [tenant, Id, Type, oneyear])

  /**************************************************************** */

  useEffect(() => {
    if (FlagReg === true) {
      if (Evento === 1 && oneyear !== '' && onemoth !== '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type !== 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGrafica(Id, oneyear, onemoth, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficaglobal(Id, oneyear, onemoth, tenant, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("All-connectors")?.classList.add('active')
        document.getElementById("IpSec")?.classList.remove('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')
      }
      else if (Evento === 1 && oneyear !== '' && onemoth !== '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type === 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGrafica(Id, oneyear, onemoth).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficaglobal(Id, oneyear, onemoth, tenant).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("All-connectors")?.classList.add('active')
        document.getElementById("IpSec")?.classList.remove('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')
      }
      ///////////////////////////////////////////////////////////////////////////////////////////////

      else if (Evento === 1 && oneyear !== '' && onemoth === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type !== 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficaanual(Id, oneyear, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficaanualGlobal(Id, oneyear, tenant, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }

        document.getElementById("All-connectors")?.classList.add('active')
        document.getElementById("IpSec")?.classList.remove('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }
      else if (Evento === 1 && oneyear !== '' && onemoth === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type === 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficaanual(Id, oneyear).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficaanualGlobal(Id, oneyear, tenant).then(response => {
            setDatos(response.data)
          })
        }

        document.getElementById("All-connectors")?.classList.add('active')
        document.getElementById("IpSec")?.classList.remove('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }

      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

      else if (Evento === 1 && oneyear === '' && onemoth === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type !== 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatodosanios(Id, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatodosaniosglobal(Id, tenant, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }

        document.getElementById("All-connectors")?.classList.add('active')
        document.getElementById("IpSec")?.classList.remove('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }
      else if (Evento === 1 && oneyear === '' && onemoth === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type === 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatodosanios(Id).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatodosaniosglobal(Id, tenant).then(response => {
            setDatos(response.data)
          })
        }

        document.getElementById("All-connectors")?.classList.add('active')
        document.getElementById("IpSec")?.classList.remove('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }
      //////////////////////////////////////////////////////////////////////////////////////////////////////////

      else if (Evento === 2 && oneyear !== '' && onemoth === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type !== 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'VPN', oneyear, onemoth, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'VPN', oneyear, onemoth, tenant, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("IpSec")?.classList.add('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }

      else if (Evento === 2 && oneyear !== '' && onemoth === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type === 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'VPN', oneyear, onemoth).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'VPN', oneyear, onemoth, tenant).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("IpSec")?.classList.add('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////

      else if (Evento === 2 && oneyear !== '' && onemoth !== '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type !== 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'VPN', oneyear, onemoth, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'VPN', oneyear, onemoth, tenant, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("IpSec")?.classList.add('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }
      else if (Evento === 2 && oneyear !== '' && onemoth !== '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type === 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'VPN', oneyear, onemoth).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'VPN', oneyear, onemoth, tenant).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("IpSec")?.classList.add('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }

      //////////////////////////////////////////////////////////////////////////
      else if (Evento === 2 && oneyear === '' && onemoth === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type !== 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'VPN', oneyear, onemoth, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'VPN', oneyear, onemoth, tenant, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("IpSec")?.classList.add('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }

      else if (Evento === 2 && oneyear === '' && onemoth === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type === 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'VPN', oneyear, onemoth).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'VPN', oneyear, onemoth, tenant).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("IpSec")?.classList.add('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }
      ///////////////////////////////////////////////////////////////////////////////////////////
      else if (Evento === 3 && oneyear !== '' && onemoth === '' && props.CPR && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type !== 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'CPR', oneyear, onemoth, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'CPR', oneyear, onemoth, tenant, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("Cloud")?.classList.add('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("IpSec")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }
      else if (Evento === 3 && oneyear !== '' && onemoth === '' && props.CPR && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type === 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'CPR', oneyear, onemoth).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'CPR', oneyear, onemoth, tenant).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("Cloud")?.classList.add('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("IpSec")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }
      ////////////////////////////////////////////////////////////////////////////////////////////

      else if (Evento === 3 && oneyear !== '' && onemoth !== '' && props.CPR && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type !== 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'CPR', oneyear, onemoth, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'CPR', oneyear, onemoth, tenant, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("Cloud")?.classList.add('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("IpSec")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }

      else if (Evento === 3 && oneyear !== '' && onemoth !== '' && props.CPR && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type === 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'CPR', oneyear, onemoth).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'CPR', oneyear, onemoth, tenant).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("Cloud")?.classList.add('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("IpSec")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }

      /////////////////////////////////////////////////////////////////////////////////

      else if (Evento === 3 && oneyear === '' && onemoth === '' && props.CPR && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type !== 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'CPR', oneyear, onemoth, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'CPR', oneyear, onemoth, tenant, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("Cloud")?.classList.add('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("IpSec")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }
      else if (Evento === 3 && oneyear === '' && onemoth === '' && props.CPR && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type === 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'CPR', oneyear, onemoth).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'CPR', oneyear, onemoth, tenant).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("Cloud")?.classList.add('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("IpSec")?.classList.remove('active')
        document.getElementById("Edge")?.classList.remove('active')

      }
      ///////////////////////////////////////////////////////////////////////////////////////////////

      else if (Evento === 4 && oneyear !== '' && onemoth === '' && props.EDG && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type !== 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'EDG', oneyear, onemoth, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'EDG', oneyear, onemoth, tenant, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("Edge")?.classList.add('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("IpSec")?.classList.remove('active')
      }
      else if (Evento === 4 && oneyear !== '' && onemoth === '' && props.EDG && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type === 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'EDG', oneyear, onemoth).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'EDG', oneyear, onemoth, tenant).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("Edge")?.classList.add('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("IpSec")?.classList.remove('active')
      }

      /////////////////////////////////////////////////

      else if (Evento === 4 && oneyear !== '' && onemoth !== '' && props.EDG && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type !== 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'EDG', oneyear, onemoth, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'EDG', oneyear, onemoth, tenant, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("Edge")?.classList.add('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("IpSec")?.classList.remove('active')
      }
      else if (Evento === 4 && oneyear !== '' && onemoth !== '' && props.EDG && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type === 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'EDG', oneyear, onemoth).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'EDG', oneyear, onemoth, tenant).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("Edge")?.classList.add('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("IpSec")?.classList.remove('active')
      }


      //////////////////////////////////////////////////
      else if (Evento === 4 && oneyear === '' && onemoth === '' && props.EDG && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type !== 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'EDG', oneyear, onemoth, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'EDG', oneyear, onemoth, tenant, Type, nameregion).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("Edge")?.classList.add('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("IpSec")?.classList.remove('active')
      }
      else if (Evento === 4 && oneyear === '' && onemoth === '' && props.EDG && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type === 'CloudGlobal' && Id !== -1 && Id !== 0) {
        if (tenant === 0) {
          getDataGraficatipo(Id, 'EDG', oneyear, onemoth).then(response => {
            setDatos(response.data)
          })
        }
        else {
          getDataGraficatipoGlobal(Id, 'EDG', oneyear, onemoth, tenant).then(response => {
            setDatos(response.data)
          })
        }
        document.getElementById("Edge")?.classList.add('active')
        document.getElementById("Cloud")?.classList.remove('active')
        document.getElementById("All-connectors")?.classList.remove('active')
        document.getElementById("IpSec")?.classList.remove('active')
      }
    }
  }, [Id, oneyear, onemoth, Evento, FlagReg, nameregion])

  /*************************GLOBAL grafica poc*************************************** */
  useEffect(() => {
    if (Evento === 1 && oneyear !== '' && onemoth !== '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type && Id) {
      if (tenant === 0) {
        getDataGrafica(Id, oneyear, onemoth).then(response => {
          setDatos(response.data)
        })
      }
      else if (tenant !== 0) {
        getDataGraficaglobal(Id, oneyear, onemoth, tenant).then(response => {
          setDatos(response.data)
        })
      }
      document.getElementById("All-connectors")?.classList.add('active')
      document.getElementById("IpSec")?.classList.remove('active')
      document.getElementById("Cloud")?.classList.remove('active')

    }

    else if (Evento === 1 && oneyear !== '' && onemoth === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type && Id) {
      if (tenant === 0) {
        getDataGraficaanual(Id, oneyear).then(response => {
          setDatos(response.data)
        })
      }
      else if (tenant !== 0) {
        getDataGraficaanualGlobal(Id, oneyear, tenant).then(response => {
          setDatos(response.data)
        })
      }

      document.getElementById("All-connectors")?.classList.add('active')
      document.getElementById("IpSec")?.classList.remove('active')
      document.getElementById("Cloud")?.classList.remove('active')
      document.getElementById("Edge")?.classList.remove('active')

    }

    else if (Evento === 1 && oneyear === '' && onemoth === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type && Id) {
      if (tenant === 0) {
        getDataGraficatodosanios(Id).then(response => {
          setDatos(response.data)
        })
      }
      else if (tenant !== 0) {
        getDataGraficatodosaniosglobal(Id, tenant).then(response => {
          setDatos(response.data)
        })
      }

      document.getElementById("All-connectors")?.classList.add('active')
      document.getElementById("IpSec")?.classList.remove('active')
      document.getElementById("Cloud")?.classList.remove('active')
      document.getElementById("Edge")?.classList.remove('active')

    }

    else if (Evento === 2 && oneyear !== '' && onemoth === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type && Id) {
      if (tenant === 0) {
        getDataGraficatipo(Id, 'VPN', oneyear, onemoth).then(response => {
          setDatos(response.data)
        })
      }
      else if (tenant !== 0) {
        getDataGraficatipoGlobal(Id, 'VPN', oneyear, onemoth, tenant).then(response => {
          setDatos(response.data)
        })
      }
      document.getElementById("IpSec")?.classList.add('active')
      document.getElementById("All-connectors")?.classList.remove('active')
      document.getElementById("Cloud")?.classList.remove('active')
      document.getElementById("Edge")?.classList.remove('active')

    }
    else if (Evento === 2 && oneyear !== '' && onemoth !== '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type && Id) {
      if (tenant === 0) {
        getDataGraficatipo(Id, 'VPN', oneyear, onemoth).then(response => {
          setDatos(response.data)
        })
      }
      else if (tenant !== 0) {
        getDataGraficatipoGlobal(Id, 'VPN', oneyear, onemoth, tenant).then(response => {
          setDatos(response.data)
        })
      }
      document.getElementById("IpSec")?.classList.add('active')
      document.getElementById("All-connectors")?.classList.remove('active')
      document.getElementById("Cloud")?.classList.remove('active')
      document.getElementById("Edge")?.classList.remove('active')

    }

    else if (Evento === 2 && oneyear === '' && onemoth === '' && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type && Id) {
      if (tenant === 0) {
        getDataGraficatipo(Id, 'VPN', oneyear, onemoth).then(response => {
          setDatos(response.data)
        })
      }
      else if (tenant !== 0) {
        getDataGraficatipoGlobal(Id, 'VPN', oneyear, onemoth, tenant).then(response => {
          setDatos(response.data)
        })
      }
      document.getElementById("IpSec")?.classList.add('active')
      document.getElementById("All-connectors")?.classList.remove('active')
      document.getElementById("Cloud")?.classList.remove('active')
      document.getElementById("Edge")?.classList.remove('active')

    }

    else if (Evento === 3 && oneyear !== '' && onemoth === '' && props.CPR && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type && Id) {
      if (tenant === 0) {
        getDataGraficatipo(Id, 'CPR', oneyear, onemoth).then(response => {
          setDatos(response.data)
        })
      }
      else if (tenant !== 0) {
        getDataGraficatipoGlobal(Id, 'CPR', oneyear, onemoth, tenant).then(response => {
          setDatos(response.data)
        })
      }
      document.getElementById("Cloud")?.classList.add('active')
      document.getElementById("All-connectors")?.classList.remove('active')
      document.getElementById("IpSec")?.classList.remove('active')
      document.getElementById("Edge")?.classList.remove('active')

    }

    else if (Evento === 3 && oneyear !== '' && onemoth !== '' && props.CPR && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type && Id) {
      if (tenant === 0) {
        getDataGraficatipo(Id, 'CPR', oneyear, onemoth).then(response => {
          setDatos(response.data)
        })
      }
      else if (tenant !== 0) {
        getDataGraficatipoGlobal(Id, 'CPR', oneyear, onemoth, tenant).then(response => {
          setDatos(response.data)
        })
      }
      document.getElementById("Cloud")?.classList.add('active')
      document.getElementById("All-connectors")?.classList.remove('active')
      document.getElementById("IpSec")?.classList.remove('active')
      document.getElementById("Edge")?.classList.remove('active')

    }

    else if (Evento === 3 && oneyear === '' && onemoth === '' && props.CPR && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type && Id) {
      if (tenant === 0) {
        getDataGraficatipo(Id, 'CPR', oneyear, onemoth).then(response => {
          setDatos(response.data)
        })
      }
      else if (tenant !== 0) {
        getDataGraficatipoGlobal(Id, 'CPR', oneyear, onemoth, tenant).then(response => {
          setDatos(response.data)
        })
      }
      document.getElementById("Cloud")?.classList.add('active')
      document.getElementById("All-connectors")?.classList.remove('active')
      document.getElementById("IpSec")?.classList.remove('active')
      document.getElementById("Edge")?.classList.remove('active')

    }

    else if (Evento === 4 && oneyear !== '' && onemoth === '' && props.EDG && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type && Id) {
      if (tenant === 0) {
        getDataGraficatipo(Id, 'EDG', oneyear, onemoth).then(response => {
          setDatos(response.data)
        })
      }
      else if (tenant !== 0) {
        getDataGraficatipoGlobal(Id, 'EDG', oneyear, onemoth, tenant).then(response => {
          setDatos(response.data)
        })
      }
      document.getElementById("Edge")?.classList.add('active')
      document.getElementById("Cloud")?.classList.remove('active')
      document.getElementById("All-connectors")?.classList.remove('active')
      document.getElementById("IpSec")?.classList.remove('active')
    }

    else if (Evento === 4 && oneyear !== '' && onemoth !== '' && props.EDG && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type && Id) {
      if (tenant === 0) {
        getDataGraficatipo(Id, 'EDG', oneyear, onemoth).then(response => {
          setDatos(response.data)
        })
      }
      else if (tenant !== 0) {
        getDataGraficatipoGlobal(Id, 'EDG', oneyear, onemoth, tenant).then(response => {
          setDatos(response.data)
        })
      }
      document.getElementById("Edge")?.classList.add('active')
      document.getElementById("Cloud")?.classList.remove('active')
      document.getElementById("All-connectors")?.classList.remove('active')
      document.getElementById("IpSec")?.classList.remove('active')
    }

    else if (Evento === 4 && oneyear === '' && onemoth === '' && props.EDG && currentUser?.ListPermiso?.includes('Ctx.DataUsage') && Type && Id) {
      if (tenant === 0) {
        getDataGraficatipo(Id, 'EDG', oneyear, onemoth).then(response => {
          setDatos(response.data)
        })
      }
      else if (tenant !== 0) {
        getDataGraficatipoGlobal(Id, 'EDG', oneyear, onemoth, tenant).then(response => {
          setDatos(response.data)
        })
      }
      document.getElementById("Edge")?.classList.add('active')
      document.getElementById("Cloud")?.classList.remove('active')
      document.getElementById("All-connectors")?.classList.remove('active')
      document.getElementById("IpSec")?.classList.remove('active')
    }
  }, [tenant, Id, oneyear, onemoth, Evento])

  /************************************************************************************* */

  if (flag === 1) {
    document.getElementById("All-Trafic")?.classList.add('active')
    document.getElementById("Outbound")?.classList.remove('active')
    document.getElementById("Inbound")?.classList.remove('active')


  }
  else if (flag === 2) {
    document.getElementById("Inbound")?.classList.add('active')
    document.getElementById("All-Trafic")?.classList.remove('active')
    document.getElementById("Outbound")?.classList.remove('active')

  }
  else if (flag === 3) {
    document.getElementById("Outbound")?.classList.add('active')
    document.getElementById("All-Trafic")?.classList.remove('active')
    document.getElementById("Inbound")?.classList.remove('active')


  }


  useEffect(() => {
    setEvento(1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  /*useEffect(() => {
    if(year.length >0){
    setoneyear(year[0]?.year)
    }
  // eslint-disable-next-line
  }, [setyear, year])*/

  useEffect(() => {
    if (oneyear) {
      setDatos([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oneyear])

  useEffect(() => {
    if (onemoth) {
      setDatos([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onemoth])


  /**************************************** */




  return (
    <>
      <div className="card card-custom">
        <div className="card-header  bg-marino">
          <h4 className="f-titulo-cards fs-sub  text-w" >Data Detail</h4>
          <div className="card-toolbar ">
            <div className='d-flex'>
            
              <select style={{ marginRight: '10px' }} name='Year' className="form-select text-center w-200px f-parrafo fs-p text-dk with-navy-border w-150px" aria-label="Select example"
                onChange={(e: any) => setoneyear(e.target.value)} value={oneyear}>
                <option value="" className='f-parrafo fs-p text-dk' >All Years</option>
                {
                  
                  year?.map((y: any) =>
                    <option className='f-parrafo fs-p text-dk' key={'year' + y.year} value={y.year}>{y.year}  </option>
                  )
                }
              </select>

              <select name='mes' className="form-select text-center w-200px f-parrafo fs-p text-dk with-navy-border w-110px" aria-label="Select example"
                onChange={(e: any) => setonemonth(e.target.value)}
                disabled={oneyear === ''}>
                <option className='f-parrafo fs-p text-dk' value=''>All Months</option>
                {
                  month?.map((m: any) =>
                    <option className='f-parrafo fs-p text-dk' key={'month' + m.id} value={m.id}>{m.month}  </option>
                  )
                }
              </select>
            </div>

          </div>

        </div>
        <br />
        <div className='row  '>
          <div className="col d-flex flex-center">
            <button type="button" className=" btn btn-light-marino fs-9  border border-marino" style={{ paddingRight: '11px', paddingLeft: '11px', marginRight: '2px' }} id='All-connectors' onClick={() => setEvento(1)} >All Connectors</button>
            {props.VPN !== null && props.VPN !== '' && props.VPN !== undefined && <button type="button" className=" btn btn-light-marino fs-9  border border-marino" style={{ marginRight: '2px' }} id='IpSec' onClick={() => setEvento(2)}>IPSec</button>}
            {props.CPR !== null && props.CPR !== '' && props.CPR !== undefined && <button type="button" className=" btn btn-light-marino fs-9  border border-marino" style={{ paddingRight: '5px', paddingLeft: '5px' }} id='Cloud' onClick={() => setEvento(3)}>Cloud Peering</button>}
            {props.EDG !== null && props.EDG !== '' && props.EDG !== undefined && <button type="button" className=" btn btn-light-marino fs-9  border border-marino" style={{ paddingRight: '5px', paddingLeft: '5px', marginLeft: '2px' }} id='Edge' onClick={() => setEvento(4)}>Edge Peering</button>}

          </div>

          <div className="col d-flex flex-center ">
            <button type="button" className=" btn btn-light-marino fs-9 border border-marino" style={{ paddingRight: '23px', paddingLeft: '23px', marginRight: '2px' }} id='All-Trafic' onClick={() => setflag(1)}>All Trafic</button>
            <button type="button" className=" btn btn-light-marino fs-9 border border-marino" style={{ paddingRight: '15px', paddingLeft: '15px', marginRight: '2px' }} id='Inbound' onClick={() => setflag(2)}>Inbound</button>
            <button type="button" className=" btn btn-light-marino fs-9 border border-marino" style={{ paddingRight: '13px', paddingLeft: '13px' }} id='Outbound' onClick={() => setflag(3)}>Outbound</button>
          </div>
        </div>

        <div className='card-scroll h-400px' style={{ marginTop: '20px' }}>

          < DataTransferBar data={Datos} flag={flag}></DataTransferBar>
        </div>


      </div>
      <DataDetail Year={oneyear} mes={onemoth}></DataDetail>
    </>
  )

}